import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2c28c904&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c28c904')) {
      api.createRecord('2c28c904', component.options)
    } else {
      api.reload('2c28c904', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=2c28c904&", function () {
      api.rerender('2c28c904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/saas/layout/Header.vue"
export default component.exports